import axios from "axios";
import {ID_TOKEN, TOKEN_STRING} from "../../conf";
import {SessionInterface} from "../interface/SessionInterface";
import {findToken, getSessionByCookie} from "../../utils/decode/getSessionByCookie";
import {getSessionToken} from "./cookiesConfig";

const tokenFromStorage = getSessionToken(ID_TOKEN);

const instance = axios.create({
    // baseURL: `https://desarrollo.cognoservices.com${BASE_URL}`,
    baseURL: `/api/data/`,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

if (tokenFromStorage) {
    const decode: SessionInterface | null = getSessionByCookie(ID_TOKEN);
    if (decode && decode?.access_token) {
        instance.defaults.headers.common.Authorization = findToken(ID_TOKEN);
    }
}

export const updateToken = (token: string) => {
    instance.defaults.headers.common.Authorization = TOKEN_STRING + token;
};

export default instance;
